import AssociateRequestModalSection from '../components/AssociateRequestsComps/AssociateRequestModalSection';
import ShowAllAssociateRequests from '../components/AssociateRequestsComps/ShowAllAssociateRequests';
import PageTitle from '../components/CommonComps/Titles/PageTitle';
import AssociateRequestProvider from '../contexts/AssociateRequestProvider';

const AssociateRequests = () => {
  // rendering associate requests page component here
  return (
    <>
      <PageTitle title='Associate Requests' />

      <AssociateRequestProvider>
        <ShowAllAssociateRequests />
        <AssociateRequestModalSection />
      </AssociateRequestProvider>
    </>
  );
};

export default AssociateRequests;
